import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiTarget, FiBox, FiGlobe } = FiIcons;

const features = [
  {
    icon: FiShield,
    title: "Enterprise-Grade Delivery",
    desc: "We build systems designed to scale, with security, high availability, and maintainability baked in from day one."
  },
  {
    icon: FiTarget,
    title: "AI-First Architecture",
    desc: "We don't just bolt on AI; we architect your software foundation to leverage machine learning capabilities natively."
  },
  {
    icon: FiBox,
    title: "End-to-End Ownership",
    desc: "From initial technical discovery to deployment and ongoing support, we take full responsibility for the product lifecycle."
  },
  {
    icon: FiGlobe,
    title: "Industry-Agnostic Expertise",
    desc: "Our horizontal technology expertise allows us to solve complex problems across manufacturing, finance, health, and more."
  }
];

const Differentiators = () => {
  return (
    <section id="approach" className="py-24 relative z-10 bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-slate-900 leading-tight">
              What Sets <span className="text-gradient-cyan">Aetrix Logic</span> Apart
            </h2>
            <p className="text-slate-600 text-lg mb-8 leading-relaxed">
              We aren't just another dev shop. We are technical partners who understand that software must drive tangible business value. Our approach combines rigorous engineering discipline with forward-thinking AI integration.
            </p>
            <div className="w-24 h-1 bg-cyan-500 mb-8 rounded-full"></div>
            <p className="text-slate-700 font-medium">
              "We bridge the gap between complex theoretical AI and practical, scalable enterprise software."
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="p-6 bg-white border border-slate-200 rounded-lg hover:shadow-md transition-all"
              >
                <SafeIcon icon={feature.icon} className="text-cyan-600 text-2xl mb-4" />
                <h4 className="text-slate-900 font-bold mb-2">{feature.title}</h4>
                <p className="text-sm text-slate-600 leading-relaxed">{feature.desc}</p>
              </motion.div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Differentiators;